/* eslint-disable max-classes-per-file */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  let elements = getFocusableElements(container);
  let first = elements[0];
  let last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", () => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const swallow = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    };

    const closeBtn = this.querySelector('[id^="ModalClose-"]');
    closeBtn?.addEventListener(
      "pointerdown",
      (e) => {
        swallow(e);
        this.hide(false);
      },
      { capture: true }
    );
    closeBtn?.addEventListener(
      "touchstart",
      (e) => {
        swallow(e);
        this.hide(false);
      },
      { capture: true, passive: false }
    );
    closeBtn?.addEventListener(
      "click",
      (e) => {
        swallow(e);
      },
      { capture: true }
    );
    this.querySelector('[role="dialog"]')?.addEventListener(
      "pointerdown",
      (e) => {
        swallow(e);
      },
      { capture: true }
    );
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        const productMediaModal = document.querySelector(
          ".product-media-modal",
        );
        const productMediaModalContent = document.querySelector(
          ".product-media-modal__content",
        );

        const clickedBackToTop =
          event.target.classList.contains("pdp-zoom-in--to-top") ||
          event.target.closest(".pdp-zoom-in--to-top");

        const clickedInsideContent = event.target.closest(
          ".product-media-modal__content",
        );

        if (clickedInsideContent) {
          if (clickedBackToTop) {
            productMediaModal?.setAttribute("open", "");
            if (productMediaModalContent) {
              productMediaModalContent.scrollTop = 0;
              productMediaModalContent.style.transition = "0.2s ease-in-out";
            }
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return;
        }

        this.hide();
      });
      this.querySelector(".pdp-zoom-in--to-top")?.addEventListener(
        "keyup",
        (event) => {
          if (event.code === "Enter" || event.code === "Space") {
            const productMediaModal = document.querySelector(
              ".product-media-modal",
            );
            const productMediaModalContent = document.querySelector(
              ".product-media-modal__content",
            );

            productMediaModal?.setAttribute("open", "");
            if (productMediaModalContent) {
              productMediaModalContent.scrollTop = 0;
              productMediaModalContent.style.transition = "0.2s ease-in-out";
            }
          }
        },
      );
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  connectedCallback() {
    if (document.querySelector('[name="options[Size]"]')) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const variant = urlParams.get("variant");

      if (!variant) {
        this.setUnavailable();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) {
      return;
    }

    if (!this.currentVariant.featured_media) {
      return;
    }

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true,
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", this.currentVariant.id);
    window.history.replaceState({}, "", url.toString());
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) {
      return;
    }
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const forms = this.getAllProductForms();
    if (!forms.length || !this.currentVariant) return;

    forms.forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;

      input.value = this.currentVariant.id;

      // IMPORTANTISSIMO: se è disabled, Shopify non lo invia nel submit
      input.disabled = false;

      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) {
      productForm.handleErrorMessage();
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }
  getAllProductForms() {
    const root = this.closest("section") || document;
    return Array.from(root.querySelectorAll('form[action$="/cart/add"]'));
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const forms = this.getAllProductForms();
    if (!forms.length) return;

    forms.forEach((form) => {
      const buttons = Array.from(form.querySelectorAll('[name="add"]'));

      buttons.forEach((btn) => {
        const btnText =
          btn.querySelector("span") || btn.querySelector('[name="add"] > span');

        if (disable) {
          btn.setAttribute("disabled", "disabled");
          btn.setAttribute("aria-disabled", "true");
          if (text && btnText) btnText.textContent = text;
        } else {
          btn.removeAttribute("disabled");
          btn.setAttribute("aria-disabled", "false"); // oppure removeAttribute
          if (btnText) btnText.textContent = btn.dataset.isPreorder ? window.variantStrings.preorder : window.variantStrings.addToCart;
        }
      });
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    if (!addButton) return;
    addButtonText.textContent = addButton.dataset.isPreorder ? window.variantStrings.preorder : window.variantStrings.addToCart;
    addButton.removeAttribute("disabled");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// swiper card
function observeProductLoad() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const newSwipers = node.querySelectorAll(".swiper-product-card");
          if (newSwipers.length > 0) {
            newSwipers.forEach((swiperContainer) =>
              initSwiper(swiperContainer),
            );
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function getProductCardSwiper(swiperContainer) {
  const config = {
    breakpoints: {
      990: {
        navigation: {
          nextEl: swiperContainer.querySelector(".swiper-button-next"),
          prevEl: swiperContainer.querySelector(".swiper-button-prev"),
        },
      },
    },
    slidesPerView: 1,
    spaceBetween: 1, //px, margin right
    scrollbar: {
      el: swiperContainer.querySelector(".swiper-scrollbar"),
      hide: false,
    },
    loop: true,
    preventClicks: false,
  };

  function handleResize() {
    const isShopTheLookChild = swiperContainer.closest(
      "fostr-shop-the-look-slide",
    );
    const hasMobileDisabled = swiperContainer.hasAttribute(
      "data-mobile-swiper-disabled",
    );
    if ((hasMobileDisabled || isShopTheLookChild) && 750 > window.innerWidth)
      swiper.disable();
    else swiper.enable();
  }

  let resizeTimeout;
  window.addEventListener("resize", () => {
    // Debounce to avoid too many recalculations
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 150);
  });

  const swiper = new Swiper(swiperContainer, config);

  handleResize();

  let canClick = true;

  swiperContainer.addEventListener("mouseenter", function () {
    if (canClick) {
      swiper.params.speed = 1;
      canClick = false;
      setTimeout(() => {
        swiper.params.speed = 300;
        canClick = true;
      }, 50);
    }
  });

  swiperContainer.addEventListener("mouseleave", function () {
    swiper.params.speed = 1;
    /* Uncomment to enable scroll to first image on mouse leave */
    // swiper.slideToLoop(0);
  });

  return swiper;
}

// EP-439 | Redesign shop the look PDP
function getShopTheLookSwiper(swiperContainer) {
  function applyCorrectWidth() {
    swiperContainer.style.width =
      750 > window.innerWidth ? window.innerWidth + "px" : "100%";
  }

  applyCorrectWidth();

  let resizeTimeout;
  window.addEventListener("resize", () => {
    // Debounce to avoid too many recalculations
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(applyCorrectWidth, 150);
  });

  const bullets = false;
  const slider = true;

  function scrollbarWidthAdjust() {
    const scrollbarWidth = this.scrollbar.el.offsetWidth;
    const slideCount = this.slides.length;
    const fixedDragSize = scrollbarWidth / (slideCount - 1);

    this.params.scrollbar.dragSize = fixedDragSize;
    this.scrollbar.updateSize();

    this.scrollbar.fixedDragSize = fixedDragSize;
    this.scrollbar.maxTranslate = scrollbarWidth - fixedDragSize;
  }

  const config = {
    navigation: {
      nextEl: swiperContainer.querySelector(
        ".shop-the-look__nav [data-action='previous']",
      ),
      prevEl: swiperContainer.querySelector(
        ".shop-the-look__nav [data-action='next']",
      ),
    },
    slidesPerView: "auto",
    spaceBetween: 1, //px, margin right
    slidesPerGroup: 1,
    simulateTouch: true,
    allowTouchMove: true,
    autoplay: false,
    on: {
      init: scrollbarWidthAdjust,
      setTranslate: function () {
        if (!swiper.scrollbar.dragEl) return;
        if (!swiper.scrollbar.maxTranslate) return;

        const transform = swiper.scrollbar.dragEl.style.transform;
        const match = transform.match(/translate3d\((-?\d+\.?\d*)px/);
        if (!match) return;

        let translateX = parseFloat(match[1]);
        translateX = Math.max(
          0,
          Math.min(translateX, swiper.scrollbar.maxTranslate),
        );
        swiper.scrollbar.dragEl.style.transform = `translate3d(${translateX}px, 0px, 0px)`;
        swiper.scrollbar.dragEl.style.width = `${swiper.scrollbar.fixedDragSize}px`;
      },
      resize: scrollbarWidthAdjust,
    },
  };

  if (bullets)
    config.pagination = {
      el: swiperContainer.querySelector(
        ".shop-the-look__pagination.swiper-pagination",
      ),
      clickable: true,
    };

  if (slider) {
    config.scrollbar = {
      el: swiperContainer.querySelector(
        ".shop-the-look__pagination.swiper-scrollbar",
      ),
      hide: false,
    };
    if (750 > window.innerWidth) {
      config.scrollbar.draggable = true;
      config.scrollbar.dragSize = "auto";
    }
  }

  const swiper = new Swiper(swiperContainer, config);
  window.shopTheLookSwiper = swiper;
  return swiper;
}

function initSwiper(swiperContainer) {
  if (swiperContainer.dataset.swiperInit === "1") return;
  swiperContainer.dataset.swiperInit = "1";

  let swiperInstance;

  if (swiperContainer.classList.contains("shop-the-look__slider")) {
    swiperInstance = getShopTheLookSwiper(swiperContainer);
  } else {
    swiperInstance = getProductCardSwiper(swiperContainer);
  }

  const doUpdate = () => {
    try {
      swiperInstance.update();
      swiperInstance.updateSize();
      swiperInstance.updateSlides();
    } catch (e) {}
  };

  // dopo load completo
  window.addEventListener("load", doUpdate, { once: true });

  // quando cambiano immagini dentro al container
  swiperContainer.querySelectorAll("img").forEach((img) => {
    if (img.complete) return;
    img.addEventListener("load", doUpdate, { once: true });
  });

  // resize
  window.addEventListener("resize", doUpdate);
}

document.addEventListener("DOMContentLoaded", () => {
  // EP-439 | Redesign shop the look PDP
  document
    .querySelectorAll(".swiper-product-card, .shop-the-look__slider")
    .forEach(initSwiper);
  observeProductLoad();
});

document.addEventListener("swiper:reinitialize", () => {
  // EP-439 | Redesign shop the look PDP
  document
    .querySelectorAll(".swiper-product-card, .shop-the-look__slider")
    .forEach(initSwiper);
});

let sendDataToKLAddToWL = function (e) {
  let data = e.detail.d;
  let customerEmail = JSON.parse(document.querySelector("script#cm").innerHTML);
  let productURL = data.du;
  let pHandle = productURL.split("/").pop();
  let urlObj = new URL(productURL);
  let productPath = urlObj.pathname;

  // Fetch product data and then send to Klaviyo
  fetch(productPath)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch product data: ${response.status}`);
      }
      return response.text();
    })
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(
        responseText,
        "text/html",
      );
      const productElement = responseHTML.querySelector(
        "fostr-variant-radios script#vStock",
      ).innerHTML;

      // Send to Klaviyo
      let url = "https://a.klaviyo.com/client/events?company_id=X5Sgey";
      let body = {
        data: {
          type: "event",
          attributes: {
            properties: {
              productHandle: pHandle,
              productStock: productElement,
            },
            metric: {
              data: {
                type: "metric",
                attributes: {
                  name: "product added to wishlist",
                },
              },
            },
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: customerEmail,
                },
              },
            },
          },
        },
      };
      let options = {
        method: "POST",
        headers: {
          revision: "2025-04-15",
          "content-type": "application/vnd.api+json",
          accept: "application/vnd.api+json",
        },
        body: JSON.stringify(body),
      };

      // Return the fetch promise so it can be chained
      return fetch(url, options);
    })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Failed to submit form data to Klaviyo: ${res.status}`);
      }
    })
    .catch((error) => {
      console.error("Error in sendDataToKLAddToWL:", error);
    });
};

let sendDataToKLRemoveFromWL = function (e) {
  let data = e.detail.d;
  let customerEmail = JSON.parse(document.querySelector("script#cm").innerHTML);
  let productURL = data.du;
  let pHandle = productURL.split("/").pop();
  let urlObj = new URL(productURL);
  let productPath = urlObj.pathname;

  // Teads pixel event
  Shopify.analytics.publish("product_added_to_wishlist", {
    productName: data.dt,
    price: data.pr,
    currency: Shopify.currency.active,
  });

  // Fetch product data and then send to Klaviyo
  fetch(productPath)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch product data: ${response.status}`);
      }
      return response.text();
    })
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(
        responseText,
        "text/html",
      );
      const productElement = responseHTML.querySelector(
        "fostr-variant-radios script#vStock",
      ).innerHTML;

      // Send to Klaviyo
      let url = "https://a.klaviyo.com/client/events?company_id=X5Sgey";
      let body = {
        data: {
          type: "event",
          attributes: {
            properties: {
              productHandle: pHandle,
              productStock: productElement,
            },
            metric: {
              data: {
                type: "metric",
                attributes: {
                  name: "product removed from wishlist",
                },
              },
            },
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: customerEmail,
                },
              },
            },
          },
        },
      };
      let options = {
        method: "POST",
        headers: {
          revision: "2025-04-15",
          "content-type": "application/vnd.api+json",
          accept: "application/vnd.api+json",
        },
        body: JSON.stringify(body),
      };

      // Return the fetch promise so it can be chained
      return fetch(url, options);
    })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`Failed to submit form data to Klaviyo: ${res.status}`);
      }
    })
    .catch((error) => {
      console.error("Error in sendDataToKLAddToWL:", error);
    });
};

if (!window.SwymCallbacks) window.SwymCallbacks = [];
window.SwymCallbacks.push(initSwymUI);

function initSwymUI(swatInstance) {
  let swat;
  swat = swatInstance;
  swat.evtLayer.addEventListener("sw:addedtowishlist", sendDataToKLAddToWL);
  swat.evtLayer.addEventListener(
    "sw:removedfromwishlist",
    sendDataToKLRemoveFromWL,
  );

  // EP-796 | Toast conferma aggiunta/rimozione wishlist
  swat.evtLayer.addEventListener("sw:addedtowishlist", () =>
    showWishlistToast("added"),
  );
  swat.evtLayer.addEventListener("sw:removedfromwishlist", () =>
    showWishlistToast("removed"),
  );
}

/** EP-796 | Toast wishlist: popup top-center sotto header, auto-chiusura 3s */
let wishlistToastTimer = null;
function showWishlistToast(action) {
  const toast = document.getElementById("wishlist-toast");
  if (!toast) return;

  showToast(
    action === "removed" ? toast.dataset.msgRemoved : toast.dataset.msgAdded,
    true,
  );
}

/** Toast generico: riusa il markup wishlist, con o senza link alla wishlist */
function showToast(message, withWishlistLink = false) {
  const toast = document.getElementById("wishlist-toast");
  if (!toast || !message) return;

  toast.querySelector(".wishlist-toast__msg").textContent = message;
  const link = toast.querySelector(".wishlist-toast__link");
  if (link) link.hidden = !withWishlistLink;

  // Posiziona a 1rem dalla fine dell'header (header sticky/variabile)
  const header = document.querySelector(".header-wrapper");
  if (header) {
    const bottom = header.getBoundingClientRect().bottom;
    toast.style.setProperty("--toast-top", `calc(${Math.max(bottom, 0)}px + 1rem)`);
  }

  toast.classList.add("is-visible");
  toast.setAttribute("aria-hidden", "false");

  // Singolo popup: resetta timer ad ogni nuova azione
  clearTimeout(wishlistToastTimer);
  wishlistToastTimer = setTimeout(() => {
    toast.classList.remove("is-visible");
    toast.setAttribute("aria-hidden", "true");
  }, 4000);
}

function getOneTrustConsentStatus() {
  const status = {
    strictly_necessary: true, // Always true
    performance: false,
    functional: false,
    targeting: false,
  };

  if (typeof OnetrustActiveGroups !== "undefined") {
    status.performance = OnetrustActiveGroups.includes("C0002");
    status.functional = OnetrustActiveGroups.includes("C0003");
    status.targeting = OnetrustActiveGroups.includes("C0004");
  }

  return status;
}

window.digestMessageSHA256 = async function (message) {
  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return hashHex.slice(0, 32);
};

/** EP-476 | Online Assessment | nl_subscription event */
window.addEventListener("newsletterFormSubmitted", async function (e) {
  const DEBUG = true;
  const { email, siteLocation } = e.detail;

  const hashedEmail = await window.digestMessageSHA256(email);

  const event = {
    event: "nl_subscription",
    hashed_email: hashedEmail,
    site_location: siteLocation,
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);

  if (DEBUG)
    console.table([
      ["Captured email", email],
      ["Hashed email", hashedEmail],
      ["Site location", siteLocation],
    ]);
  if (DEBUG) console.debug("DataLayer pushed:", event);
});

/** EP-476 | Online Assessment | nl_subscription event */
// Track processed submissions to prevent duplicates
window._processedKlaviyoSubmissions =
  window._processedKlaviyoSubmissions || new Set();

window.addEventListener("klaviyoForms", function (e) {
  /** @see https://www.pucci.com/pages/newsletter-subscription */
  const DEBUG = false;
  e.preventDefault();

  const { type, metaData } = e.detail;
  if (DEBUG) console.debug("[Klaviyo form]", { type, metaData });
  // if (!["submit", "submitBackInStockForm"].includes(type)) return;
  if (!metaData) return;

  const { $source, $email, opt_in_promotional_email } = metaData;
  if (DEBUG)
    console.debug("[Klaviyo form]", {
      $source,
      $email,
      opt_in_promotional_email,
    });

  // Create a unique key for this submission to prevent duplicates
  const submissionKey = `${$email}_${Date.now()}`;
  const submissionKeyShort = `${$email}_${Math.floor(Date.now() / 1000)}`; // Same second

  // Check if we've already processed this submission in the last second
  if (window._processedKlaviyoSubmissions.has(submissionKeyShort)) {
    if (DEBUG)
      console.debug(
        "[Klaviyo form]",
        "Duplicate submission detected, skipping",
      );
    return;
  }

  // Mark this submission as processed
  window._processedKlaviyoSubmissions.add(submissionKeyShort);

  // Clean up old entries after 5 seconds to prevent memory leaks
  setTimeout(() => {
    window._processedKlaviyoSubmissions.delete(submissionKeyShort);
  }, 5000);

  let valid = true;

  if (!valid) return;

  const customEvent = new CustomEvent("newsletterFormSubmitted", {
    detail: {
      email: $email || undefined,
      siteLocation: window.theme.siteLocation || undefined,
    },
  });

  window.dispatchEvent(customEvent);

  if (DEBUG) console.log("[Klaviyo form]", "Newsletter form submitted!");
});

// sincronizza filtri collezione speciale //
function syncScarvesPillsState(root = document) {
  const form = document.getElementById("FacetFiltersForm");
  if (!form) return;

  root
    .querySelectorAll(".filter-pill[data-param-name][data-value]")
    .forEach((pill) => {
      const paramName = pill.dataset.paramName;
      const value = pill.dataset.value;

      const selector =
        'input[name="' +
        CSS.escape(paramName) +
        '"][value="' +
        CSS.escape(value) +
        '"]';
      const input = form.querySelector(selector);

      const disabled = !input || input.disabled;
      pill.classList.toggle("is-disabled", disabled);

      const active = input && input.checked;
      pill.classList.toggle("scarves-pill--active", !!active);

      pill.setAttribute("aria-disabled", disabled ? "true" : "false");
    });
}
